const OVERRIDE_ERROR_MESSAGE = 'Method must be overridden in a child class.';

class GlobalConstants {
	static get OVERRIDE_ERROR_MESSAGE() {
		return OVERRIDE_ERROR_MESSAGE;
	}
}

export default GlobalConstants;
